import { API_BASE_URL, fetchWithAuth } from '@/lib/api'

/** Merge askQuestion or flashCardSession onto a saved assistant message. */
export async function patchChatMessageMetadata(
  messageId: string,
  patch: Record<string, unknown>,
): Promise<void> {
  if (!messageId) return
  try {
    await fetchWithAuth(`${API_BASE_URL}/api/chat-stream/message-metadata`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messageId, patch }),
    })
  } catch (err) {
    console.error('[ChatPane] Failed to persist choice widget:', err)
  }
}
